import { MerchantSetupProgressSchema } from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getMerchantSetupProgressForTeam = {
  name: "getMerchantSetupProgressForTeam" as const,
  input: z.null(),
  output: zExt.filterToValidArray(MerchantSetupProgressSchema),
};
